import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import MemberAreaPage from './pages/MemberAreaPage';
import MitraAreaPage from './pages/MitraAreaPage';
import DaftarTernakPage from './pages/DaftarTernakPage';
import CowInvestmentDetailPage from './pages/CowInvestmentDetailPage';
import CatalogPage from './pages/CatalogPage';
import CowDetailPage from './pages/CowDetailPage';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import RegistrasiForm from './components/RegistrasiForm';
import LoginForm from './components/LoginForm';
import FAQPage from './components/FAQPage';
import ContactPage from './pages/ContactPage';

function AppContent() {
  const location = useLocation();
  const isMemberArea = location.pathname === '/member-area';
  const isMitraArea = location.pathname === '/mitra-area';
  const isDaftarTernak = location.pathname === '/daftar-ternak';
  const isCowInvestmentDetail = location.pathname.startsWith('/detail-investasi-sapi');
  const isLoginPage = location.pathname === '/login';
  const isFAQPage = location.pathname === '/faq';
  const isContactPage = location.pathname === '/kontak';
  const [showRegistrasiForm, setShowRegistrasiForm] = useState(false);

  return (
    <div className="App">
      {!isMemberArea && !isMitraArea && !isDaftarTernak && !isCowInvestmentDetail && !isLoginPage && !isFAQPage && !isContactPage && <Header onShowRegistrasi={() => setShowRegistrasiForm(true)} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginForm onShowRegistrasi={() => setShowRegistrasiForm(true)} />} />
        <Route path="/member-area" element={<MemberAreaPage />} />
        <Route path="/mitra-area" element={<MitraAreaPage />} />
        <Route path="/daftar-ternak" element={<DaftarTernakPage />} />
        <Route path="/detail-investasi-sapi/:id" element={<CowInvestmentDetailPage />} />
        <Route path="/katalog" element={<CatalogPage />} />
        <Route path="/katalog/:id" element={<CowDetailPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/kontak" element={<ContactPage />} />
      </Routes>
      {!isMemberArea && !isMitraArea && !isDaftarTernak && !isCowInvestmentDetail && !isLoginPage && !isFAQPage && !isContactPage && <Footer />}
      {!isMemberArea && !isMitraArea && !isDaftarTernak && !isCowInvestmentDetail && !isLoginPage && !isFAQPage && !isContactPage && <FloatingWhatsApp />}
      
      {/* Registrasi Form Modal - Global Level */}
      {showRegistrasiForm && (
        <RegistrasiForm 
          onBack={() => setShowRegistrasiForm(false)}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

